module.exports = __webpack_public_path__ + "img/block-numbers.a8fdbeee.png";